import { render } from "./CustomPanelCard.vue?vue&type=template&id=02c18730&scoped=true"
import script from "./CustomPanelCard.vue?vue&type=script&lang=js"
export * from "./CustomPanelCard.vue?vue&type=script&lang=js"

import "./CustomPanelCard.vue?vue&type=style&index=0&id=02c18730&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c18730"]])

export default __exports__